export default config = {
    headers: {
        NETOAPI_ACTION: "GetCategory",
        NETOAPI_USERNAME: "administrator",
        NETOAPI_KEY: "1L6erGMpkUmna3PMlrljxzTGadgjjTpz",
      },
}